export type DisplaySettings = {
    showLabels: boolean;
    coloringType: ColoringType;
};

export enum ColoringType {
    OutlinesColor,
    UniquePerObject,
}
